function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

var modal_controller = {
    class: 'modal',
    active_class: 'active',
    hash_parse: function () {
        var hash = window.location.hash;
        if (hash.length == 0) {
            return;
        } else {
            var $target = jQuery(hash);
            if (
                $target.length
                && $target.hasClass(modal_controller.class)
            ) {
                jQuery('.'+modal_controller.class).removeClass(modal_controller.active_class);
                $target.addClass(modal_controller.active_class);
                jQuery('.modal-container').addClass('active');
            }
        }
    },
    init: function () {
        var sub_menu_item = jQuery('#navbar-desktop .sub-menu li.current-menu-item');
        if(sub_menu_item.length > 0){
            var $parent = sub_menu_item.closest('#navbar-desktop > li');
            if(!$parent.hasClass('current_page_ancestor')){
                $parent.addClass('current_page_ancestor');
            }
        }
        this.hash_parse();
        jQuery('a[href*="#"]:not([href="#"])').click(function () {
            var target = jQuery(this.hash);

            if (!target.hasClass('modal')) {
                if (target.length) {
                    jQuery('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            } else {
                if (!target.hasClass('active')) {
                    target.addClass('active');
                }
            }
        });
        jQuery('.modal .close-modal').click(function () {
            jQuery(this).closest('.modal').removeClass('active');
            jQuery('.modal-container').removeClass('active');
            history.pushState({}, '', window.location.pathname);
        });
    },
};

var mobile_menu = {
    init: function () {
        jQuery('.navbar-toggler').click(function () {

            var $target = jQuery('#' + jQuery(this).attr('aria-controls'));

            if ($target.attr('aria-expanded') == 'true') {
                //jQuery('.navbar-toggler').find('i').removeClass('icon-plus').removeClass('rotate-45').addClass('icon-bars');
            }else{
                //jQuery('.navbar-toggler').find('i').removeClass('icon-bars').addClass('icon-plus').addClass('rotate-45');
            }

            $target.toggleClass('active');

            //$target.slideToggle(150, function () {
                if ($target.attr('aria-expanded') == 'true') {
                    $target.attr('aria-expanded', 'false'); 
                    jQuery('html').removeClass('locked');
                } else {
                    $target.attr('aria-expanded', 'true');
                    jQuery('html').addClass('locked');
                }
            //});
        });

        jQuery('.mobile-menu-contain nav ul li .sub-menu-toggle').click(function (e) {
            e.preventDefault();
            var $this = jQuery(this);
            var $parent = jQuery(this).parent();
            var $target = $this.siblings('.sub-menu');
            $target.addClass('active');
            $target.attr('aria-expanded', 'true');
            jQuery('#navbar-mobile .sub-menu.active')[0].scrollTo(0,0);
        });

        jQuery('.mobile-menu-contain nav ul li .sub-menu .up-nav').click(function (e) {
            e.preventDefault();
            var $parent = jQuery(this).closest('.sub-menu');
            $parent.removeClass('active');
            $parent.attr('aria-expanded', 'false');
            jQuery('#navbar-mobile .sub-menu.active')[0].scrollTo(0,0);
        });

        jQuery('.mobile-menu-contain .close-nav').click(function (e) {
            e.preventDefault();
            var $toggler = jQuery('.navbar-toggler');
            var $target = jQuery('#' + $toggler.attr('aria-controls'));
            $target.removeClass('active');
            jQuery('html').removeClass('locked');
            $target.attr('aria-expanded', 'false');
            $target.find('.sub-menu').removeClass('active');
            $target.find('.sub-menu').attr('aria-expanded', 'false');
        });

        jQuery(document).on('click', '.mobile-menu-contain li:not([aria-expanded="true"]) .mobile_expander', function (e) {
            e.preventDefault();
            jQuery('.mobile-menu-contain li[aria-expanded="true"]').attr('aria-expanded', 'false').find('.sub-menu').slideUp(200);
            let $parent = jQuery(this).parent();
            jQuery(this).siblings('.sub-menu').slideDown(100, function () {
                if ($parent.attr('aria-expanded') == 'true') {
                    $parent.attr('aria-expanded', 'false');
                } else {
                    $parent.attr('aria-expanded', 'true');
                }
            });
        });

        jQuery(document).on('click', '.mobile-menu-contain li[aria-expanded="true"] .mobile_expander', function (e) {
            e.preventDefault();
            jQuery(this).parent().attr('aria-expanded', 'false');
            jQuery(this).siblings('.sub-menu').slideUp(100);
        });
    }
};

var menu_controller = {
    product_menu_selector: '.sub-menu-contain.products > .sub-menu > li[data-menu-selector]:not([data-legacy-menu])',
    legacy_menu_selector: '.sub-menu-contain.products > .sub-menu > li[data-legacy-menu]',
    menu_selector_prop: 'menu-selector',
    legacy_menu_selector_prop: 'sub-menu-selector',
    menu_prop: 'menu-parent',
    legacy_menu_prop: 'sub-menu-parent',
    product_selector: '.sub-menu-contain.products li.product a',
    legacy_product_selector: '.sub-menu-contain.products li.legacy-model a',
    nested_legacy_product_selector: 'li.legacy-model a',
    legacy_product_category_selector: '.sub-menu-contain.products li.legacy-model-category',
    product_selector_prop: 'product-id',
    top_level_menu_item_selector: '#navbar-desktop > li.menu-item',
    menu_delay: 600,
    menu_timeout: null,
    mouse_enter: function(dom){
        var $dom = jQuery(dom);
        var $all_items = jQuery(menu_controller.top_level_menu_item_selector);
        $all_items.not($dom).removeClass('hover');
        menu_controller.clear_menu_timeout();
        if(!$dom.hasClass('hover')){
            $dom.addClass('hover');
        }
    },
    mouse_leave: function(dom){
        var $dom = jQuery(dom);
        menu_controller.menu_timeout = setTimeout(function(){
            $dom.removeClass('hover');
            menu_controller.reset_product_menu();
        }, menu_controller.menu_delay);
    },
    reset_product_menu: function(){
        var $sub_menu_contain = jQuery('.sub-menu-contain.products');
        $sub_menu_contain.find('*').removeClass('active').removeClass('inactive');
        
        var $apex_menu = $sub_menu_contain.find('li[data-menu-selector="2"]');
        var $apex_500 = $sub_menu_contain.find('li[data-sub-menu-selector="2-2"]');
        
        $apex_menu.addClass('active');
        $apex_500.addClass('active');
    },
    clear_menu_timeout: function(){
        clearTimeout(menu_controller.menu_timeout);
        menu_controller.menu_timeout = null;
    },
    select_product_menu: function (dom){
        var $dom = jQuery(dom);
        var menu_selector = $dom.data(menu_controller.menu_selector_prop);
        var $menu = jQuery('.sub-menu[data-'+menu_controller.menu_prop+'="'+menu_selector+'"]');
        if($menu.length > 0){
            var $not_menu = jQuery('.sub-menu[data-'+menu_controller.menu_prop+'!="'+menu_selector+'"]');
            $not_menu.removeClass('active').addClass('inactive');
            $menu.removeClass('inactive').addClass('active');

            // Add additional logic to select the first product.
            var $product = jQuery(menu_controller.product_selector).first();
            $product.trigger('mouseenter');
        }
    },
    select_product: function (dom){
        $dom = jQuery(dom);
        var product_id = $dom.data(menu_controller.product_selector_prop);
        var $product = jQuery('.product-flyout[data-id="'+product_id+'"]');
        var $not_product = jQuery('.product-flyout[data-id!="'+product_id+'"]');
        if($product.length > 0){
            $not_product.removeClass('active').addClass('inactive');
            $product.removeClass('inactive').addClass('active');
        }
    },
    select_legacy_product_menu: function(dom){
        var $dom = jQuery(dom);
        var menu_selector = $dom.data(menu_controller.menu_selector_prop);
        var $menu = jQuery('.sub-menu[data-'+menu_controller.menu_prop+'="'+menu_selector+'"]');
        if($menu.length > 0){
            var $not_menu = jQuery('.sub-menu[data-'+menu_controller.menu_prop+'!="'+menu_selector+'"]');
            $not_menu.removeClass('active').addClass('inactive');
            $menu.removeClass('inactive').addClass('active');

            // Add additional logic to select the first category.
            var $category = jQuery(menu_controller.legacy_product_category_selector).first();
            $category.trigger('mouseenter');

            // Add additional logic to select the first product.
            /*var $product = jQuery.find(menu_controller.legacy_product_selector).first();
            $product.trigger('mouseenter');*/
        }
    },
    select_legacy_product_submenu: function(dom){
        var $dom = jQuery(dom);
        //console.log($dom);
        var menu_selector = $dom.data(menu_controller.legacy_menu_selector_prop);
        //console.log(menu_selector);
        var $menu = jQuery('.sub-menu[data-'+menu_controller.legacy_menu_prop+'="'+menu_selector+'"]');
        var $menu_parent = $menu.parent();
        if($menu.length > 0){
            var $not_menu = $menu_parent.find('.sub-menu[data-'+menu_controller.legacy_menu_prop+'!="'+menu_selector+'"]');
            $not_menu.removeClass('active').addClass('inactive');
            $menu.removeClass('inactive').addClass('active');

            // Add additional logic to select the first product.
            $product = $menu.find(menu_controller.nested_legacy_product_selector).first();
            $product.trigger('mouseenter');
            //console.log('product', $product);
            
        }
    },
    select_legacy_product: function(dom){
        menu_controller.select_product(dom);
        var $dom = jQuery(dom);
        //console.log($dom);
        if($dom.closest('.product-menus').length > 0){
            //This hides the sub menu if a legacy product is highlighted in the parent menu
            //console.log('NEED TO HIDE SUB MENU');
            var $menu = jQuery('.product-sub-menus .sub-menu');
            //console.log($menu);
            $menu.removeClass('active').addClass('inactive');
        }
    },
    clear_legacy_product_menu: function(){
        var $menu = jQuery('.product-sub-menus .sub-menu');
        $menu.removeClass('active').addClass('inactive');
        var $products = jQuery('.product-flyout');
        $products.removeClass('active').addClass('inactive');
    },
    init: function () {
        jQuery(menu_controller.product_menu_selector).on('mouseenter', function () {
            menu_controller.select_product_menu(this);
        });
        jQuery(menu_controller.product_selector).on('mouseenter', function () {
            menu_controller.select_product(this);
        });
        jQuery(menu_controller.legacy_menu_selector).on('mouseenter', function () {
            menu_controller.select_legacy_product_menu(this);
        });
        jQuery(menu_controller.legacy_product_category_selector).on('mouseenter', function () {
            menu_controller.select_legacy_product_submenu(this);
        });
        jQuery(menu_controller.legacy_product_selector).on('mouseenter', function () {
            menu_controller.select_legacy_product(this);
        });
        jQuery('.sub-menu-contain.products .sub-menu .menu-item.page:not(.menu-item-has-children)').on('mouseenter', function () {
            menu_controller.clear_legacy_product_menu();
        });
        jQuery('.sub-menu .menu-item').on('mouseenter', function () {
            var $dom = jQuery(this);
            var $not_dom = $dom.closest('.sub-menu').find('.menu-item').not($dom);
            $not_dom.removeClass('active');
            $dom.removeClass('inactive').addClass('active');
        });

        jQuery(this.top_level_menu_item_selector).on('mouseenter', function () {
            menu_controller.mouse_enter(this);
        }).on('mouseleave', function () {
            menu_controller.mouse_leave(this);
        });


    }
};

var dialog_controller = {
    close_closest_dialog: function(dom){
		var $dialog = jQuery(dom).closest('dialog');
		$dialog[0].close();
		$dialog.remove(); //Remove the dialog from the DOM
	},
    loading_closest_dialog: function(dom){
        var $dialog = jQuery(dom).closest('dialog');
        $dialog.addClass('loading');
    },
    loaded_closest_dialog: function(dom){
        var $dialog = jQuery(dom).closest('dialog');
        $dialog.removeClass('loading');
    },
	display_dialog: function(message, controls, css_class){
        if(typeof css_class == 'undefined'){
            css_class = '';
        }else{
            css_class = ' ' + css_class;
        }
		var $dialog = jQuery('<dialog class="syn-dialog'+css_class+'"></dialog>');
        var dialog_template = '<header><button class="close-dialog"><i class="icon icon-close-x-circle"></i></button></header>';
        
        if (message.title) {
            dialog_template += '<span class="title">' + message.title + '</span>';
        }

        if (message.content) {
            dialog_template += '<div class="message">' + message.content + '</div>';
        }

		$dialog.html(dialog_template);
		$dialog.find('.close-dialog').on('click', function(){
			dialog_controller.close_closest_dialog(this);
		});
		if(typeof controls != 'undefined' && controls.length > 0){
			$dialog.append('<div class="controls"></div>');
			for(var i = 0; i < controls.length; i++){
                var class_string = '';
                if(controls[i].class){
                    class_string = ' ' + controls[i].class;
                }
				var $control = jQuery('<button class="cta cta-button dialog-control alt'+ class_string+'">' + controls[i].text + '</button>');
				$control.on('click', controls[i].callback);
				$dialog.find('.controls').append($control);
			}
		}
		$dialog.appendTo('body');
		$dialog[0].showModal();

        //Return the dialog so that it can be manipulated further if needed.
        return $dialog;
	},
};

window.dialog_controller = dialog_controller;

var mini_cart_controller = {
    ajax_url: false,
    template: false,
    is_updating_count: false,
    to_send_with_update: [],
    pending_messages: {
        'success': [],
        'error': [],
    },
    get_cart: function(){
        var data = {
            action: 'get_quick_cart',
            additional_data: this.to_send_with_update,
        };

        this.to_send_with_update = []; //Clear the array after sending it.

        jQuery.post(mini_cart_controller.ajax_url, data, function(response){
            //console.log(response);
            
            mini_cart_controller.handle_data(response);
        });
    },
    on_adding_to_cart: function(event, button, details){
        mini_cart_controller.to_send_with_update.push(details);
    },
    remove_item: function(item_id){
        var data = {
            action: 'remove_item_from_cart',
            product_id: item_id,
        };
        var original_target = toast_controller.toast_target;
        toast_controller.toast_target = '.qq-toast-container';
        jQuery.post(mini_cart_controller.ajax_url, data, function(response){
            if(typeof response.cart_count != 'undefined'){
                mini_cart_controller.handle_data(response);
                toast_controller.toast_target = original_target;
            }
            jQuery(document.body).trigger('removed_from_cart', [response]);
        });
    },
    render_template: function(template, data){
        var html = template;
        for(var key in data){
            var regex = new RegExp('{{' + key + '}}', 'g');
            html = html.replace(regex, data[key]);
        }
        return html;
    },
    get_template: function(){
        var template = jQuery('.quick-cart .qq-template').html();
        return template;
    },
    get_mobile_template: function(){
        var template = jQuery('.quick-cart--mobile .qq-template').html();
        return template;
    },
    handle_data: function(data){
        var new_cart = '';
        if(data.cart){
            for(var i in data.cart){
                var item = data.cart[i];
                new_cart += this.render_template(this.template, item);
            }
        }

        if (data.cart_count > 0) {
            jQuery('.quick-cart--mobile').addClass('has-items');    
            jQuery('.qq-holder--mobile').addClass('has-items');    
        } else {
            jQuery('.quick-cart--mobile').removeClass('has-items');    
            jQuery('.qq-holder--mobile').removeClass('has-items');    
        }

        jQuery('.quick-cart .qq-items').html(new_cart);
        jQuery('.quick-cart--mobile .qq-items').html(new_cart);
        jQuery('.quick-cart .qq-subtotal-amount').html(data.subtotal);
        jQuery('.quick-cart--mobile .qq-subtotal-amount').html(data.subtotal);

        // removed animation because it is causing issues on desktop and mobile
        // the animation fires multiple times even before the mobile quick cart work
        // the big issue is when users are removing an item from the cart
        // this.animate_count(data.cart_count, jQuery('.woocomm-account-menu .qq-holder .count-holder'));
        
        // dont animate just replace 
        jQuery('.woocomm-account-menu .qq-holder .count-holder .cart-count').text(data.cart_count);
        jQuery('.qq-holder--mobile .count-holder .cart-count').text(data.cart_count);
        
        jQuery('.cta.add_to_cart_button').removeClass('icon-spinner').addClass('icon-cart');

        if(typeof data.notices != 'undefined'){
            for(var i in data.notices){
                var type = i;
                var notices = data.notices[i];
                for(var j in notices){
                    var notice = notices[j];
                    if(type == 'error'){
                        toast_controller.display_toast(notice, 'error');
                    }else if(type == 'success'){
                        toast_controller.display_toast(notice, 'success');
                    }
                }
            }
        }
    },
    animate_count: function(new_count, element){
        var $count_holder = element;
        var height = $count_holder.height();
        var transition_height = height + 5;
        var $parent = $count_holder.closest('.icon');
        $parent.css('height', height).css('overflow', 'hidden');
        $count_holder.append('<span class="cart-count">' + new_count + '</span>');
        $count_holder.css('transition', 'transform 0.5s').css('transform', 'translateY(-' + transition_height + 'px)');
        setTimeout(function(){
            $count_holder.find('.cart-count').first().remove();
            $count_holder.css('transition', 'none').css('transform', 'translateY(0)');
            $parent.css('height', 'auto').css('overflow', 'visible');
        }, 500);

    },
    init: function(){
        this.ajax_url = site_vars.ajax_url;
        this.template = this.get_template();
        this.mobile_template = this.get_mobile_template();
        jQuery(document.body).on('added_to_cart removed_from_cart update_cart cart_page_refreshed updated_wc_div wc_cart_emptied', function(e){
            //console.log('Cart Event', e, data, data2, data3, data4);
            mini_cart_controller.get_cart();
        });
        jQuery(document.body).on('adding_to_cart', function(e, button, details){
            mini_cart_controller.on_adding_to_cart(e, button, details);
        });
        /*jQuery('.cta.add_to_cart_button').click(function(){
            var $this = jQuery(this);
            $this.removeClass('icon-cart').addClass('icon-spinner');
        });*/
        jQuery(window).on('click', function(e){
            if(jQuery(e.target).is('.cta.add_to_cart_button:not(.disabled)')){
                var $this = jQuery(e.target);
                $this.removeClass('icon-cart').addClass('icon-spinner');
            }
        });

        jQuery('.quick-cart .qq-items').on('click', '.qq-item-remove', function(e){
            var $this = jQuery(this);
            var item_id = $this.data('product-id');
            var $item = $this.closest('.qq-item');

            window.LoaderCollection.create($item[0]);
            $item.trigger('loader:show');

            // $item.slideUp(200);
            mini_cart_controller.remove_item(item_id);
        });

        //No click events for disabled buttons
        jQuery('.add_to_cart_button.disabled').off('click');
    }
};

var toast_controller = {
    toast_target: false,
    toast_timeout: 5000,
    toast_template: '<div class="toast {{type}}"><i class="icon icon-toast-warning"></i><span class="message">{{message}}</span> <span class="controls">{{controls}} <button class="close" type="button"><i class="icon icon-toast-close"></i></button></span></div>',
    render_template: function(template, data){
        var html = template;
        for(var key in data){
            var regex = new RegExp('{{' + key + '}}', 'g');
            html = html.replace(regex, data[key]);
        }
        if(typeof data.controls == 'undefined' || data.controls.length == 0){
            html = html.replace('{{controls}}', '');
        }
        return html;
    },
    display_toast: function(message, type, controls){
        if(typeof message == 'object'){
            if(typeof message.type != 'undefined'){
                type = message.type;
            }
            if(typeof message.controls != 'undefined'){
                controls = message.controls;
            }
            if(typeof message.notice != 'undefined'){
                message = message.notice;
            }
        }
        if(typeof controls == 'undefined'){
            controls = '';
        }
        var data = {
            message: message,
            type: type,
            controls: controls,
        };
        var toast = this.render_template(this.toast_template, data);
        var target = this.toast_target;
        if(target === false){
            target = 'main .toast-container';
        }
        var $toast = jQuery(toast);
        //var $toast = jQuery(target).find('.toast').last();
        $toast.find('.close').click(function(){
            clearTimeout($toast.timeout);
            $toast.slideUp(200, function(){
                $toast.remove();
            });
        });

        if(
            type != 'error'
            //false
        ){
            $toast.timeout = setTimeout(function(){
                $toast.slideUp(200, function(){
                    $toast.remove();
                });
            }, this.toast_timeout);
        }
        $toast.css('display', 'none');
        jQuery(target).prepend($toast);
        $toast.slideDown(200);
        //console.log('TOAST', message, type, $toast);
    },
    pop_notices: function(){
        $wc_selector = jQuery('.woocommerce-notices-wrapper, .woocommerce-NoticeGroup');

        var $messages = $wc_selector.find('.woocommerce-message');
        var $errors = $wc_selector.find('.woocommerce-error li');

        if($messages.length > 0){
            $messages.each(function(){
                var message = jQuery(this).text();
                toast_controller.display_toast(message, 'success');
            });
        }

        if($errors.length > 0){
            var emit_event = false;
            $errors.each(function(index){
                var message = jQuery(this).text();
                var id = $errors.eq(index).data('id');
                // console.log('Error ID', id);
                if(jQuery('#' + id).length > 0){
                    var $target = jQuery('#' + id);
                    $target.addClass('woocommerce-invalid');
                    var $error_message = jQuery('<div class="woocommerce-error">' + message + '</div>');
                    //$error_message.insertAfter($target);
                    emit_event = true;
                    $target.on('change', function(){
                        $target.removeClass('woocommerce-invalid');
                        $error_message.fadeOut(200, function(){
                            $error_message.remove();
                        });
                    });
                }else{
                    toast_controller.display_toast(message, 'error');
                }
            });

            if(emit_event){
                jQuery(document.body).trigger('syn_checkout_error');
            }
        }
    },
    init: function(){
        this.pop_notices();
        jQuery(document.body).on('checkout_error', function(){
            toast_controller.pop_notices();
        });
    },
};

function check_user_agent(){
    var user_agent = navigator.userAgent;
    if(user_agent.indexOf('Mac') != -1){
        document.body.classList.add('mac');
    }else{
        return false;
    }
}
check_user_agent();

window.toast_controller = toast_controller;

window.mini_cart_controller = mini_cart_controller;

var quantity_controller = {
    init: function(){
        jQuery(document).on('click', '.quantity__control--increment', function(){
            var $input = jQuery(this).siblings('input');
            // console.log($input);

            var value = parseInt($input.val());
            var new_value = value + 1;

            $input.val(new_value);

            $input.trigger('change');
            $input.trigger('syn:quantity_change', {
                value: new_value,
                triggering_element: this,
            });

            quantity_controller.update_add_to_cart($input, value + 1);
        });
        jQuery(document).on('click', '.quantity__control--decrement', function(){
            var $input = jQuery(this).siblings('input');
            var min = $input.attr('min');
            if(!min){
                min = 1;
            }
            var value = parseInt($input.val());
            if(value > min){
                var new_value = value - 1;

                $input.val(new_value);
                quantity_controller.update_add_to_cart($input, value - 1);

                $input.trigger('change');
                $input.trigger('syn:quantity_change', {
                    value: new_value,
                    triggering_element: this,
                });
            }else{
                $input.trigger('syn:quantity_min_reached', {
                    value: value,
                    triggering_element: this,
                });
            }
        });
        jQuery(document).on('change', '.quantity__controls .quantity', function(){
            var $input = jQuery(this);
            var value = parseInt($input.val());

            quantity_controller.update_add_to_cart($input, value);
        });
    },
    update_add_to_cart: function(dom, value){
        jQuery(dom).closest('.add-to-cart').find('.add_to_cart_button').attr('data-quantity', value);
    }
}

var lazy_anim_observer = {
    instances : {},
    init: function(ident, options){
        if(typeof options == 'undefined'){
            var options = {
                screen_b: jQuery(window).innerHeight() - 300,
                loaded_class: 'in_view',
                remove_when_out: false
            }
        }
        var to_return = {
            ident: ident,
            screen_b: options.screen_b,
            loaded_class: options.loaded_class,
            remove_when_out: options.remove_when_out,
            check: function(dom, buffer){
                var math_buffer = lazy_anim_observer.instances[ident].screen_b;
                if(buffer == false){
                    math_buffer = jQuery(window).innerHeight();
                }
                var top = jQuery(dom).offset().top;
                if(top < (jQuery(window).scrollTop() + math_buffer)){
                    return true;
                }
                return false;
            },
            load: function(dom){
                jQuery(dom).addClass(lazy_anim_observer.instances[ident].loaded_class);
            },
            unload: function(dom){
                //console.log('Unloading');
                jQuery(dom).removeClass(lazy_anim_observer.instances[ident].loaded_class);
            },
            loop: function(object, buffer){
                if(typeof buffer == 'undefined'){
                    var buffer = true;
                }
                var items = jQuery(lazy_anim_observer.instances[ident].ident);
                var pass_this = lazy_anim_observer.instances[ident];
                items.each(function(i){
                    var dom = items[i];
                    if(pass_this.check(dom, buffer)){
                        pass_this.load(dom);
                    }else if(pass_this.remove_when_out){
                        pass_this.unload(dom);
                    }
                });
            },
            page_load: function(){
                lazy_anim_observer.instances[ident].loop({}, false);
            },
            init: function(){
                jQuery(window).on('scroll', lazy_anim_observer.instances[ident].loop);
                lazy_anim_observer.instances[ident].page_load();
            }
        };
        this.instances[ident] = to_return;
        to_return.init();
        return to_return;
    }
};

var form_error_controller = {
    display_error: function(message){
        dialog_controller.display_dialog({
            title: '<strong>Error</strong>',
            content: message,
        }, [{
            text: 'OK',
            callback: function(){
                dialog_controller.close_closest_dialog(this);
            },
        }], 'syn-dialog--small');
    },
    init: function(){
        jQuery(document.body).on('wpcf7spam wpcf7mailfailed', function(data){
            var message = data.detail.apiResponse.message;
            form_error_controller.display_error(message);
        });
    }
};

window.form_error_controller = form_error_controller;

function syn_alert_replace(message){
    var original_message = message;
    var message = {
        title: '<strong>Alert</strong>',
        content: original_message,
    };

    var controls = [{
        text: 'OK',
        callback: function(){
            dialog_controller.close_closest_dialog(this);
        },
    }];

    dialog_controller.display_dialog(message, controls);
}

function syn_handle_cf7_form_submission(){
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        const formId = event.detail.contactFormId;
        let redirect_path;

        switch (formId) {
            case 4:
                redirect_path = `/support/contact-support/thank-you/`;
                break;

            case 2276065:
                redirect_path = `/support/become-a-dealer/register-confirmation/`;
                break;

            case 2276057:
                redirect_path = `/support/register-your-portacool/register-confirmation/`;
                break;

            case 2276120:
                redirect_path = `/support/warranty/request-return/request-confirmation/`;
                break;

            case 2276400:
                redirect_path = `/company/contact-us/thank-you/`;
                break;

            default:
                break;
        }

        if (redirect_path) {
            setTimeout( () => {
                location = `${window.location.origin}${redirect_path}`;
            }, 1300 );
        }
    }, false );
}

function syn_cf7_max_repeater_fields(max = 5) {
    $('body').on('wpcf7-field-groups/added wpcf7-field-groups/removed wpcf7-field-groups/change', function (event, $group) {
        var $groupCollection = $(event.target).closest('.wpcf7-field-groups');
    
        var maxCount = max;
        var currentCount = $groupCollection.find('.wpcf7-field-group ').length;
    
        if (currentCount === maxCount) {
            switch (event.type) {
                case "wpcf7-field-groups/added":
                    $groupCollection.find(".wpcf7-field-group-add").css('display', 'none');
                    break;
    
                case "wpcf7-field-groups/removed":
                    $groupCollection.find(".wpcf7-field-group-add").css('display', 'inline-block');
                    break;
            }
        }
    });

    $('body').on('wpcf7-field-groups/change', function (event, $group) {
        var $groupCollection = $(event.target).closest('.wpcf7-field-groups');
        var $form = $(event.target).closest('form.wpcf7-form');
    
        var currentCount = $groupCollection.find('.wpcf7-field-group ').length;
    
        $form.attr('data-repeater-count', currentCount);
    });
}

class OverflowAutoIndicator {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.active = false;
        this.iconClass = 'icon icon-mobile-swipe-gesture-left-right';
        this.template = `<div class="scroll-indicator"><i class="${this.iconClass}"></i></div>`;
        this.observer = null;

        this.init();
        this.listenGlobally();
    }

    get indicator() {
        return this.$wrapper.parent().find('.scroll-indicator');
    }

    init() {
        setTimeout(() => {
            this.handleResize();
        }, 500)
        this.setupObserver();
    }

    listenGlobally() {
        jQuery(window).on('resize', debounce(this.handleResize.bind(this), 300));
    }

    handleResize() {
        if (
            !this.$wrapper ||
            this.$wrapper.length === 0
        ) return;

        if (this.$wrapper[0].scrollWidth !== this.$wrapper[0].clientWidth) {
            if (!this.active) {
                this.activate();
            }
        } else {
            if (this.active) {
                this.deactivate();
            }
        }
    }

    activate() {
        this.active = true;

        if (this.indicator.length === 0) {
            this.$wrapper.parent().append(this.template);
        }

        this.indicator.addClass('is-active');

        this.indicator.on('animationend', () => {
            this.deactivate();
        });
    }

    deactivate() {
        this.active = false;

        this.indicator.removeClass('is-active');
        this.indicator.removeClass('in-view');
    }

    setupObserver() {
        if (!this.$wrapper || this.$wrapper.length === 0) return;

        const options = {
            root: null,
            threshold: 0.1
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.activate();
                } else {
                    this.deactivate();
                }
            });
        }, options);

        this.observer.observe(this.indicator[0]);
    }
}
class OverflowAuto {
    constructor(container, item_selector) {
        this.container = container;
        this.item_selector = item_selector;
        this.$container = jQuery(container);
        this.$columns = this.$container.find(item_selector);
        this.wrapperTemplate = '<div class="overflow-auto-wrapper"></div>';
        this.indicator = null;
        this.active = false;
        
        this.shouldCreateIndicator();

        this.init();
        this.listenGlobally();
    }

    init() {
        this.wrapColumns();
    }

    get $wrapper() {
        return this.$container.find('.overflow-auto-wrapper');
    }

    set $wrapper($element) {
        if (this.indicator) {
            this.indicator.$wrapper = $element;
        }
    }

    shouldCreateIndicator() {
        if (
            this.$container.data('overflowTabletIndicator') &&
            !this.indicator
        ) { 
            this.indicator = new OverflowAutoIndicator(this.$wrapper);
        }
    }

    removeAnimations() {
        this.$container.removeClass('stagger-animation stagger-animation--stagger-fade-in-from-left stagger-animation-delay--300');

        this.$columns.each((index, element) => {
            const $element = jQuery(element);
            $element.removeClass('animation animation--fade-in-from-left animation-delay--300 animation-delay--600');
        });
    }

    wrapColumns() {
        if (window.innerWidth <= 1200) {
            if(this.$columns.length > 0){
                this.removeAnimations();
                this.$columns.wrapAll(this.wrapperTemplate);
                this.$wrapper = this.$container.find('.overflow-auto-wrapper')
                this.listen();
            }
        }
    }

    listenGlobally() {
        jQuery(window).on('resize', debounce(this.handleResize.bind(this), 300));
    }

    listen() {
        this.$wrapper.on('scroll.overflow_auto', debounce(this.handleScroll.bind(this), 300));
        this.$wrapper.on('touchstart.overflow_auto', debounce(this.handleTouch.bind(this), 300));
    }

    cleanup() {
        this.$wrapper.off('scroll.overflow_auto');
        this.$wrapper.off('touchstart.overflow_auto');
    }

    handleResize() {
        if (window.innerWidth <= 1200) {
            if (!this.active) {
                this.shouldCreateIndicator();
                this.activate();
            }
        } else {
            if (this.active) {
                this.deactivate();
            }
        }
    }

    handleScroll() {
        this.indicator.deactivate();
        this.cleanup();
    }

    handleTouch() {
        this.indicator.deactivate();
        this.cleanup();
    }

    activate() {
        if(this.$columns.length > 0){
            if (!this.$columns.parent().hasClass('overflow-auto-wrapper')) {
                this.active = true;
                this.wrapColumns();
            }
        }
    }

    deactivate() {
        this.active = false;

        this.$columns.unwrap('.overflow-auto-wrapper');
        this.$wrapper = null;

        this.cleanup();
    }
}

jQuery(document).ready(function ($) {
    modal_controller.init();
    menu_controller.init();
    mobile_menu.init();
    mini_cart_controller.init();
    quantity_controller.init();
    form_error_controller.init();
    setTimeout(function(){
        toast_controller.init();
    }, 1000); //Delay the toast controller so that it can be configured by external scripts before the first fire.

    if(jQuery('.lazy_anim:not(.in-out)').length > 0){
        lazy_anim_observer.init('.lazy_anim:not(.in-out)', {
            screen_b: jQuery(window).innerHeight() - 300,
            loaded_class: 'in_view',
            remove_when_out: false
        }); 
    }

    syn_handle_cf7_form_submission();
    syn_cf7_max_repeater_fields(5);

    //Enable below for wc event debugging
    jQuery(document.body).on(
        "init_checkout payment_method_selected update_checkout updated_checkout checkout_error applied_coupon_in_checkout removed_coupon_in_checkout adding_to_cart added_to_cart removed_from_cart wc_cart_button_updated cart_page_refreshed cart_totals_refreshed wc_fragments_loaded init_add_payment_method wc_cart_emptied updated_wc_div updated_cart_totals country_to_state_changed updated_shipping_method applied_coupon removed_coupon",
        function (e, ...args) {
        //   console.log(e.type, args)
        }
      );

    // wrap vertical columns
    new OverflowAuto('.overflow-tablet', '.vertical-card-column');
    new OverflowAuto('.overflow-tablet', '.horizontal-card-column');

    // trigger loader if coupon form on cart is submitted
    jQuery(document).on('submit', 'form.woocommerce-cart-form', function(){
        jQuery('.woocommerce').addClass('loading')
    });
});

//Proxying the Alert function to use the custom dialog, because WooCommerce utilizes the native alert function.

window.alert = function(message){
    syn_alert_replace(message);
}

if(typeof window.prototype != 'undefined'){
    window.prototype.alert = function(message){
        syn_alert_replace(message);
    }
}

// Tooltips
class Tooltip {
    constructor(element) {
        this.element = element;
        this.tip = element.getAttribute('data-tooltip');
        this.tooltip = null;
        this.icon = null;
        this.popup = null;
        this.active = false;

        this.init();
    }

    init() {
        this.render();
        this.listen();
    }

    render() {
        this.tooltip = document.createElement('div');
        this.tooltip.classList.add('syn-tooltip');
        
        this.icon = document.createElement('i');
        this.icon.classList.add('syn-tooltip__icon');

        this.popup = document.createElement('span');
        this.popup.classList.add('syn-tooltip__popup');
        this.popup.textContent = this.tip;
        
        this.tooltip.appendChild(this.icon);
        this.tooltip.appendChild(this.popup);

        this.element.appendChild(this.tooltip);
    }

    listen() {
        this.icon.addEventListener('click', this.toggle.bind(this));
    }
    
    toggle() {
        if (this.active) {
            this.deactivate();
        } else {
            jQuery(document).trigger('syn_tooltip:close');
            this.activate();
        }
    }

    detectIfOffScreen() {
        const rect = this.tooltip.getBoundingClientRect();
        const popup = this.tooltip.querySelector('.syn-tooltip__popup');

        // if its going off to the left
        if (popup.offsetWidth > rect.left) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--left');
        }

        if (rect.right + popup.offsetWidth > window.innerWidth) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--right');
        }

        if (rect.top > popup.offsetHeight) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--top');
        }

        if (rect.bottom + popup.offsetHeight > window.innerHeight) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--bottom');
        }
    }
    
    activate() {
        this.detectIfOffScreen();
        this.tooltip.classList.add('is-active');
        this.active = true;
    }

    deactivate() {
        this.tooltip.classList.remove('offset');
        this.tooltip.classList.remove('offset--left');
        this.tooltip.classList.remove('offset--right');
        this.tooltip.classList.remove('offset--top');
        this.tooltip.classList.remove('offset--bottom');
        this.tooltip.classList.remove('is-active');
        this.active = false;
    }
}

class TooltipCollection {
    constructor(group) {
        this.group = group;
        this.collection = [];
        this.overlay;
        
        this.init();
        this.listen();
    }

    init() {
        this.group.forEach(element => {
            this.collection.push( new Tooltip(element) );
        });
    }

    listen() {
        jQuery(document).on('syn_tooltip:close', this.closeAll.bind(this));
    }

    closeAll() {
        this.collection.forEach(tooltip => {
            tooltip.deactivate();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const tooltips = document.querySelectorAll('[data-tooltip]');
    const tooltipCollection = new TooltipCollection(tooltips);
});

// Loader
class LoaderCollection {
    constructor(selectors) {
      this.selectors = selectors;
      this.collection = [];
      this.id = 0;
  
      this.init();
    }
  
    init() {
        this.selectors.forEach(selector => {
            const elements = jQuery(selector);
        
            if (elements.length > 0) {
                elements.each((index, element) => {
                    this.create(element);
                });
            }
        });
    }

    create(element) {
        this.collection.push(new Loader(element, this.id++));
    }
  }
  
  class Loader {
    constructor(form, index) {
      this.id = index;
      this.form = form;
  
      this.render();
      this.listen();
    }
  
    get template() {
      let html = document.createElement("div");
  
      html.classList.add("syn-loader");
  
      html.innerHTML = `<div class="loader__wrapper">
                    <i class="loader__image icon icon-spinner" />
                </div>`;
  
      return html;
    }
  
    render() {
      this.form.appendChild(this.template);
    }
  
    listen() {
      jQuery(this.form).on("wpcf7submit", () => {
        this.hide();
      });
  
      jQuery(this.form).on(
        "wpcf7mailsent wpcf7mailfailed wpcf7invalid wpcf7spam",
        () => {
          this.hide();
        }
      );
  
      jQuery(this.form).on("loader:show", () => {
        this.show();
      });
  
      jQuery(this.form).on("loader:hide", () => {
        this.hide();
      });
    }
  
    show() {
      if (
        this.form.tagName === "BODY" ||
        this.form.parentNode.tagName === "BODY"
      ) {
        this.form.classList.add("loader-lock");
      }
  
      this.form.classList.add("loader-is-active");
    }
  
    hide() {
      if (
        this.form.tagName === "BODY" ||
        this.form.parentNode.tagName === "BODY"
      ) {
        this.form.classList.remove("loader-lock");
      }
  
      this.form.classList.remove("loader-is-active");
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.LoaderCollection = new LoaderCollection([".wpcf7-form"]);
});

// Custom CF7 File Input
// Requires the _file_upload_widget.js script to be added to the theme
class CF7FileInput {
    constructor(element) {
        this.$container = jQuery(element).closest('.wpcf7-form-control-wrap');
        this.$input = jQuery(element);
        this.name = this.$input.attr('name');
        this.accept = this.$input.attr('accept');
        this.$customInput = null;
        this.customInputTemplate = `
        <div class="uploaded"></div>
        <div class="syn-upload upload">
            <input name="${this.name}" type="file" accept="${this.accept}" aria-label="Upload File">
            <button type="button" aria-label="Upload File">
                <i class="icon icon-upload-plus"></i>
            </button>
        </div>`;

        this.init();
    }

    init() {
        this.$container.addClass('syn-upload-container');
        this.$input.after(this.customInputTemplate);

        this.$customInput = this.$container.find('.syn-upload');

        this.$input.hide();

        this.listen();
    }

    listen() {
        this.$customInput.on('file_upload_widget:change', this.update.bind(this));
    }

    update(event, data) {
        this.renderImage(data);

        this.syncInput(data);
    }

    renderImage(data) {
        for (const file of data.file_list) {
            const $uploaded = this.$container.find('.uploaded');
            const img_src = URL.createObjectURL(file);

            $uploaded.empty();
            
    
            $uploaded.append(`<div class="uploaded-photo"><img src="${img_src}" alt="${file.name}" title="${file.name}"/></div>`);
        }
    }

    syncInput(data) {
        const $input = this.$container.find('input[type="file"]');
        $input.prop('files', data.file_list);
    }
}
class CF7FileInputCollection {
    constructor(selector) {
        this.selector = selector;
        this.collection = [];
    
        this.init();
      }
    
      init() {
        const elements = jQuery(this.selector);
    
        if (elements.length > 0) {
          elements.each((index, element) => {
            this.collection.push(new CF7FileInput(element, index));
          });
        }
      }
}

document.addEventListener('DOMContentLoaded', () => {
    new CF7FileInputCollection('.wpcf7-file');
});

class CF7CountryStateSelect {
    constructor(element) {
        this.$form = jQuery(element);
        this.$country = this.$form.find('select.syn-country-select');
        this.$state = this.$form.find('select.syn-state-select');
        this.legend = {
            'United States': [
                "Alabama",
                "Alaska",
                "Arizona",
                "Arkansas",
                "California",
                "Colorado",
                "Connecticut",
                "Delaware",
                "Florida",
                "Georgia",
                "Hawaii",
                "Idaho",
                "Illinois",
                "Indiana",
                "Iowa",
                "Kansas",
                "Kentucky",
                "Louisiana",
                "Maine",
                "Maryland",
                "Massachusetts",
                "Michigan",
                "Minnesota",
                "Mississippi",
                "Missouri",
                "Montana",
                "Nebraska",
                "Nevada",
                "New Hampshire",
                "New Jersey",
                "New Mexico",
                "New York",
                "North Carolina",
                "North Dakota",
                "Ohio",
                "Oklahoma",
                "Oregon",
                "Pennsylvania",
                "Rhode Island",
                "South Carolina",
                "South Dakota",
                "Tennessee",
                "Texas",
                "Utah",
                "Vermont",
                "Virginia",
                "Washington",
                "West Virginia",
                "Wisconsin",
                "Wyoming"
            ],
            'Canada': [
                "Alberta",
                "British Columbia",
                "Manitoba",
                "New Brunswick",
                "Newfoundland and Labrador",
                "Northwest Territories",
                "Nova Scotia",
                "Nunavut",
                "Ontario",
                "Prince Edward Island",
                "Quebec",
                "Saskatchewan",
                "Yukon"
            ],
            'Mexico': [
                "Aguascalientes",
                "Baja California",
                "Baja California Sur",
                "Campeche",
                "Chiapas",
                "Chihuahua",
                "Coahuila",
                "Colima",
                "Durango",
                "Guanajuato",
                "Guerrero",
                "Hidalgo",
                "Jalisco",
                "México",
                "Michoacán",
                "Morelos",
                "Nayarit",
                "Nuevo León",
                "Oaxaca",
                "Puebla",
                "Querétaro",
                "Quintana Roo",
                "San Luis Potosí",
                "Sinaloa",
                "Sonora",
                "Tabasco",
                "Tamaulipas",
                "Tlaxcala",
                "Veracruz",
                "Yucatán",
                "Zacatecas"
            ]
        }

        if (this.$country.length > 0 && this.$state.length > 0) {
            this.init();
        }
    }

    init() {
        this.$country.on('change', this.updateState.bind(this));

        this.$country.val('United States');
        this.$country.trigger('change');
    }

    updateState() {
        const country = this.$country.val();
        const state = this.$state.val();

        this.$state.empty();

        if (this.legend[country]) {
            this.$state.append(`<option value>Select...</option>`);
            this.legend[country].forEach(state => {
                this.$state.append(`<option value="${state}">${state}</option>`);
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wpcf7-form').forEach(form => {
        new CF7CountryStateSelect(form);
    });
});

class CF7RegisteredProductFieldGroup {
    constructor(element) {
        this.element = element;
        this.$element = jQuery(element);
        this.inputs = this.$element.find('input, select').not('.wpcf7-field-group-count').not('.hs-input');

        this.init();
        this.listen();
    }

    get id() {
        return this.inputs[0].name.slice(this.inputs[0].name.search('__') + 2);
    }

    get hbForm() {
        return jQuery('body').find(`.registered-products-form--${this.id}`);
    }

    init() {
        
    }

    destroy() {
        this.inputs.off('change.cf7_rpfg:change');
    }

    listen() {
        this.inputs.on('change.cf7_rpfg:change', this.update.bind(this));
    }

    async submit() {
        await jQuery(this.hbForm).find('form').submit();
    }

    update(event) {
        const element = event.target;
        let value = element.value;
        let name = element.name;
        
        if (name.includes('month') || name.includes('year')) {
            // delay update for date fields because of the setting of the hidden date field
            setTimeout(() => {
                value =  this.$element.find(`input[name="date_of_purchase_full__${this.id}"]`).val();
                name = `date_of_purchase`;

                if (!value) return;
            
                const inputs = this.hbForm.find('input, select');
        
                inputs.each((index, input) => {
                    if (input.name.includes(name)) {
                        input.value = value;
                    }
                });
            }, 1000);
        } else {
            name = name.slice(0, name.search('__'));
            
            const inputs = this.hbForm.find('input, select');
    
            inputs.each((index, input) => {
                if (input.name.includes(name)) {
                    input.value = value;
                }
            });
        }
    }

    updateGlobalFields(event) {
        const element = event.target;
        const value = element.value;
        const name = element.name;

        this.hbForm.find(`input[name="${name}"]`).val(value);
    }
}
class CF7RegisteredProducts {
    constructor(selector, opts) {
        this.collection = [];
        this.selector = selector;
        this.$form = jQuery(selector);
        this.options = opts;
        this.currentId = 1;
        this.$delaySubmitButton = this.$form.find('button#hsSubmit');
        this.validationRegex = {
            'email': /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
            'text': /^[a-zA-Z0-9\s]{2,100}$/,
            'date': /^\d{2}\/\d{2}\/\d{4}$/,
            'hidden': /^\d{2}\/\d{2}\/\d{4}$/,
            'select': /^(?!Month|Year|Select\.\.\.).*$/,
        }
        this.validationMessage = 'Please fill out all required fields.';

        this.init();
        this.listen();
    }

    init() {
        if (this.options.globalFields) {
            this.options.globalFields.forEach(field => {
                this.$form.on('change', `input[name="${field}"]`, this.updateGlobalFields.bind(this));
            });
        }
        // find the initial field groups on the form
        this.$form.find('#products .wpcf7-field-group').each((index, group) => {
            this.collection.push(new CF7RegisteredProductFieldGroup(group));
            this.currentId++;
        });
    }

    listen() {
        jQuery('body').on('wpcf7-field-groups/added wpcf7-field-groups/removed', this.reinit.bind(this));
        
        this.$delaySubmitButton.on('click', this.handleDelaySubmit.bind(this));
    }

    validate() {
        let valid = true;

        if (this.options.globalFields) {
            this.options.globalFields.forEach(field => {
                this.$form.find(`input[name="${field}"]`).not('.hs-input').not('.wpcf7-field-group-count').each((index, input) => {
                    let key = input.type;

                    switch (input.nodeName) {
                        case 'INPUT':
                            key = input.type;
                            break;

                        case 'SELECT':
                            key = 'select';
                            break;

                        case 'TEXTAREA':
                            key = 'text';
                            break;
                    
                        default:
                            break;
                    }

                    if (
                        !input.value ||
                        !this.validationRegex[key].test(input.value)
                    ) {
                        jQuery(input).addClass('invalid wpcf7-not-valid');
                        valid = false;
                    }
                });
            });
        }

        this.collection.forEach(group => {
            group.inputs.each((index, input) => {
                let key = input.type;

                switch (input.nodeName) {
                    case 'INPUT':
                        key = input.type;
                        break;

                    case 'SELECT':
                        key = 'select';
                        break;

                    case 'TEXTAREA':
                        key = 'text';
                        break;
                
                    default:
                        break;
                }

                if (
                    !input.value ||
                    !this.validationRegex[key].test(input.value)
                ) {
                    jQuery(input).addClass('invalid wpcf7-not-valid');
                    valid = false;
                }
            });
        });

        return valid;
    }

    async handleDelaySubmit() {
        this.$form.trigger('loader:show');

        if (this.options.globalFields) {
            this.options.globalFields.forEach(field => {
                this.$form.find(`input[name="${field}"]`).trigger('change');
            });
        }

        const isValid = this.validate();

        if (isValid) {
            const submitForms = async () => {
                for (const group of this.collection) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    await group.submit();
                }
            };
            
            await submitForms();
            
            this.$form.find('#cf7Submit').trigger('click');
        } else {
            this.$form.trigger('loader:hide');
            alert(this.validationMessage);
        }
    }

    reinit(event, data) {
        // we have to destroy all objects and reinitialize them as the repeater plugin swaps IDs by index
        this.collection.forEach(group => {
            group.destroy();
        });

        this.collection = [];

        this.$form.find('#products .wpcf7-field-group').each((index, group) => {
            this.collection.push(new CF7RegisteredProductFieldGroup(group));
        });
    }

    updateGlobalFields(event) {
        this.collection.forEach(group => {
            group.updateGlobalFields(event);
        });
    }
} 

document.addEventListener('DOMContentLoaded', () => {
    window.cf7regprod = new CF7RegisteredProducts('body.register-your-portacool .wpcf7-form', {
        globalFields: ['email']
    });
});

class CF7MonthYearField {
    constructor(element) {
        this.$selectMonth;
        this.$selectYear;
        this.$wrapper = jQuery(element);
        this.$hiddenInput = this.$wrapper.find('input[type="hidden"]');
        this.monthMap = {
            'January': 1,
            'February': 2,
            'March': 3,
            'April': 4,
            'May': 5,
            'June': 6,
            'July': 7,
            'August': 8,
            'September': 9,
            'October': 10,
            'November': 11,
            'December': 12
        };

        this.init();
    }

    init() {
        this.$wrapper.find('select').each((index, select) => {
            if (select.name.includes('year')) {
                this.$selectYear = jQuery(select);
            }

            if (select.name.includes('month')) {
                this.$selectMonth = jQuery(select);
            }
        });

        if (this.$selectMonth && this.$selectYear) {
            this.listen();
        }
    }

    listen() {
        this.$selectMonth.on('change.cf7_myf:change', this.updateValueToLong.bind(this));
        this.$selectYear.on('change.cf7_myf:change', this.updateValueToLong.bind(this));
    }

    validate() {
        if (!this.$selectMonth.val() || !this.$selectYear.val()) {
            return false;
        }

        return true
    }

    updateValueToLong() {
        const d = new Date();

        if (!this.validate()) {
            this.$hiddenInput.val('');
        } else {
            const month = this.monthMap[this.$selectMonth.val()];
            const year = this.$selectYear.val();
    
            d.setFullYear(year);
            d.setMonth(month - 1);

            let displayMonth = month;

            if (displayMonth < 10) {
                displayMonth = `0${displayMonth}`;
            }
    
            // format the date like 01/01/2021
            // always going to be the first of the month as CRM systems only accept this format
            this.$hiddenInput.val(`01/${displayMonth}/${d.getFullYear()}`);
        }

    }

    destroy() {
        this.$selectMonth.off('change.cf7_myf:change');
        this.$selectYear.off('change.cf7_myf:change');
    }
}

class CFMonthYearFields {
    constructor(selector) {
        this.collection = [];
        this.selector = selector;

        this.init();
        this.listen();
    }

    init() {
        jQuery(this.selector).each((index, element) => {
            this.collection.push(new CF7MonthYearField(element));
        });
    }

    listen() {
        jQuery(document).on('wpcf7-field-groups/added', this.reinit.bind(this));
    }

    reinit() {
        this.collection.forEach(field => {
            field.destroy();
        });

        jQuery(this.selector).each((index, element) => {
            this.collection.push(new CF7MonthYearField(element));
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CFMonthYearFields('.wpcf7-form .month-year-selects');
});

class WooSingleProductImageGallery {
    constructor(element) {
        this.$container = jQuery(element);
        this.$wrapper = this.$container.find('.woocommerce-product-gallery__wrapper');
        this.$images = this.$wrapper.find('img');
        this.$stage = this.$wrapper.find('.woocommerce-product-gallery__main-image');
        this.$thumbs = this.$wrapper.find('.woocommerce-product-gallery__thumbs');

        this.init();
    }

    init() {
        this.listen();
    }

    render() {
        this.$stage = jQuery(`<div class="woocommerce-product-gallery__main-image"></div>`)
        this.$thumbs = jQuery(`<div class="woocommerce-product-gallery__thumbs"></div>`);

        // move images into main
        this.$images.each((index, image) => {
            const $image = jQuery(image).clone();
            this.$stage.append($image);

            if (index === 0) {
                $image.addClass('is-active');
            }
        })

        // move rest of images into thumbs
        this.$images.each((index, image) => {
            const $image = jQuery(image).clone();
            this.$thumbs.append($image);

            if (index === 0) {
                $image.addClass('is-active');
            }
        });

        this.$wrapper.empty();
        this.$wrapper.append(this.$stage);
        this.$wrapper.append(this.$thumbs);
    }

    listen() {
        this.$thumbs.on('click', 'img', this.updateMainImage.bind(this));
    }

    updateMainImage(event) {
        const $target = jQuery(event.target);
        const index = $target.data('index');
        
        this.$stage.find(`img`).removeClass('is-active');
        this.$stage.find(`img[data-index="${index}"]`).addClass('is-active');

        this.$thumbs.find(`img`).removeClass('is-active');
        $target.addClass('is-active');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('body.single-product .woocommerce-product-gallery').forEach(element => {
        new WooSingleProductImageGallery(element);
    });
});

class GTMEvent {
    constructor(event, data = {}) {
        this.event = event;
        this.data = data;

        this.init();
    }

    init() {
        this.push();
    }

    push() {
        if(typeof(gtm4wp_datalayer_name) !== 'undefined'){
            window[gtm4wp_datalayer_name].push({
                'event': this.event,
                ...this.data
            });
        } else {
            window.dataLayer.push({
                'event': this.event,
                ...this.data
            });
        }

    }
}


class GTMWoocommerce {
    /**
     * Creates an instance of GTMWoocommerce.
     * @param {Object} [options] - Configuration options.
     * @param {Object} [options.triggers] - CSS selectors for event triggers.
     * @param {string} [options.triggers.removeFromCart] - Selector for remove from cart button.
     * @param {boolean} [options.debug] - Enable debug logging.
     */
    constructor(options = { 
        triggers: {
            removeFromCart: '.remove_from_cart_button'
        },
        debug: false
    }) {
        this.options = options;
        this.init();
    }

    init() {
        this.listen();
    }

    listen() {
        jQuery(document).on('added_to_cart', this.addedToCart.bind(this));
        jQuery(document).on('click', this.options.triggers.removeFromCart, this.removedFromCart.bind(this));
    }

    addedToCart(event, fragments, cart_hash, $button) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=en&client_type=gtm#add_to_cart

        if (this.options.debug) {
            console.groupCollapsed('added_to_cart');
            console.log(event);
            console.log(fragments);
            console.log(cart_hash);
            console.log($button);
            console.groupEnd();
        }
        
        new GTMEvent('add_to_cart');
    }

    removedFromCart(event) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=en&client_type=gtm#remove_from_cart

        if (this.options.debug) {
            console.groupCollapsed('removed_from_cart');
            console.log(event);
            console.groupEnd();
        }

        new GTMEvent('remove_from_cart');
    }

    addShippingInfo(event) {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=en&client_type=gtm#add_shipping_info

        if (this.options.debug) {
            console.groupCollapsed('add_shipping_info');
            console.log(event);
            console.groupEnd();
        }

        new GTMEvent('add_shipping_info');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.GTMWoocommerce = new GTMWoocommerce({
        currency: 'USD',
        triggers: {
            removeFromCart: '.remove_from_cart_button, .qq-item-remove, .product-details .remove-item, .product-details .icon-trash',
        },
        debug: false
    });
});

// Simple animations
class SimpleAnimation {
    constructor(element) {
        this.element = element;
        this.animationClass = this.getAnimationClass();
        this.offset = 1000;
        this.delay = this.getDelay(); // Added delay property

        this.init();
        this.observe();
    }

    init() {
        // if element is already in view or above the offset, add the animation class
        const boundingClientRect = this.element.getBoundingClientRect();
        const isIntersectingWithOffset = boundingClientRect.top < (window.innerHeight - this.offset) && boundingClientRect.bottom > this.offset;
        const hasScrolledPast = boundingClientRect.top < 0;

        if (isIntersectingWithOffset || hasScrolledPast) {
            this.element.classList.add('override-animation');
        }
    }

    observe() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setTimeout(() => this.startAnimation(), this.delay); // Added delay before starting animation
                } else {
                    this.stopAnimation();
                }
            });
        });

        this.observer.observe(this.element);
    }

    getAnimationClass() {
        const classes = this.element.classList;

        let animationClass = null;

        classes.forEach((className) => {
            if (className.includes('animation--')) {
                animationClass = className.replace('animation--', '');
            }
        });

        return animationClass;
    }

    getDelay() {
        const classes = this.element.classList;

        let delay = null;

        classes.forEach((className) => {
            if (className.includes('animation-delay--')) {
                delay = className.replace('animation-delay--', '');
            }
        });

        return delay ? parseInt(delay, 10) : 0; // Default delay is 0 if not specified
    }

    startAnimation() {
        if (this.isAnimating) return;
        this.isAnimating = true;

        this.element.classList.add('is-active');
    }

    stopAnimation() {
        if (!this.isAnimating) return;
        this.isAnimating = false;

        this.element.classList.remove('is-active');
    }

    destroy() {
        this.observer.disconnect();
    }
}

class SimpleAnimationCollection {
    constructor(selector) {
        this.selector = selector;
        this.collection = [];

        this.init();
    }

    init() {
        const elements = document.querySelectorAll(this.selector);

        if (elements.length > 0) {
            elements.forEach((element) => {
                this.create(element);
            });
        }
    }

    create(element) {
        const simpleAnimation = new SimpleAnimation(element);
     
        this.collection.push(simpleAnimation);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.SimpleAnimationCollection = new SimpleAnimationCollection('.animation');

    // handle staggered animations
    const staggered = document.querySelectorAll('.stagger-animation');

    if (staggered.length > 0) {
        
        staggered.forEach((element) => {
            const delay = (() => {
                const classes = element.classList;
                let delay = 0;

                classes.forEach((className) => {
                    if (className.includes('stagger-animation-delay--')) {
                        delay = className.replace('stagger-animation-delay--', '');
                    }
                });

                return delay ? parseInt(delay, 10) : 0; // Default delay is 0 if not specified
            })();

            const animation = (() => {
                const classes = element.classList;

                let animationClass = null;
        
                classes.forEach((className) => {
                    if (className.includes('stagger-animation--stagger-')) {
                        animationClass = className.replace('stagger-animation--stagger-', '');
                        // animationClass = className.replace('stagger-', '');
                    }
                });
        
                return animationClass;
            })();

            const staggeredChildren = element.querySelector('.flex-inner').childNodes;

            if (staggeredChildren.length > 0) {
                staggeredChildren.forEach((child, index) => {
                    const staggeredDelay = delay * index;

                    if (!child.classList.contains('override-animation')) {
                        child.classList.add(`animation`);
                        child.classList.add(`animation--${animation}`);
                        child.classList.add(`animation-delay--${staggeredDelay}`);

                        window.SimpleAnimationCollection.create(child);
                    }
                });
            }
        });
    }


    // overrides for heros
    const hero = document.querySelectorAll('.syn-hero-container');

    if (hero.length > 0) {
        hero.forEach((element) => {
            const text = element.querySelector('.column.text');

            window.SimpleAnimationCollection.create(text);
        });
    }
});

class MobileQuickCart {
    constructor() {
        this.$trigger = document.getElementById('mobileQuickCartTrigger');
        this.$target = document.getElementById('mobileQuickCartTarget');
        this.$close = document.getElementById('mobileQuickCartClose');
        this.active = false;

        this.listen();
    }

    listen() {
        this.$trigger.addEventListener('click', this.handleTriggerClick.bind(this));
        this.$close.addEventListener('click', this.handleCloseClick.bind(this));
    }

    handleTriggerClick() {
        if (this.active) {
            this.close();
        } else {
            this.open();
        }

        this.active = !this.active;
    }

    handleCloseClick() {
        this.close();
        this.active = false;
    }

    open() {
        this.$target.classList.add('is-active');
        this.$trigger.classList.add('is-active');
        document.documentElement.classList.add('mobile-quick-cart-open');
    }

    close() {
        this.$target.classList.remove('is-active');
        this.$trigger.classList.remove('is-active');
        document.documentElement.classList.remove('mobile-quick-cart-open');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.MobileQuickCart = new MobileQuickCart();
});